// extracted by mini-css-extract-plugin
export default {"loginWrapper":"Login_loginWrapper__nXf8q","loginBlock":"Login_loginBlock__X3M4O"};